export default "__VITE_ASSET__Cai6McSa__"